module.exports = __webpack_public_path__ + "img/folder_info.1b39f176.svg";